import React from "react";
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const ContactSocialIcons = () => {
  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col gap-4">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/918885066991"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        title="WhatsApp Us"
      >
        <FaWhatsapp size={24} />
      </a>
      
      {/* Phone Button */}
      <a
        href="tel:+918885066991"
        className="bg-primary hover:bg-orange-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        title="Call Us"
      >
        <FaPhone size={24} />
      </a>
    </div>
  );
};

export default ContactSocialIcons;
